export const MenuListendpoint = {
    MenuList_list: `/api/v1/admin/food-gallery`,
    AddMenu_List: `/api/v1/admin/food-gallery/upload-food-image`,
    ActiveInactive: `/api/v1/admin/food-gallery/toggle-active/`,
    DeleteMenu: `/api/v1/admin/food-gallery/food-image/`,
    UpdateFoodMenu :`/api/v1/admin/food-gallery/food-image/`
  };
  